import classNames from "classnames";
import { Icon } from "components";
import styles from "./Checkbox.module.css";

const CHECKED_ICONS = {
  radio: "radio_button_checked",
  checkbox: "check_box",
};

const UNCHECKED_ICONS = {
  radio: "radio_button_unchecked",
  checkbox: "check_box_outline_blank",
};

interface CheckboxProps extends React.PropsWithChildren {
  name: string;
  label?: string;
  value: string;
  type?: "checkbox" | "radio";
  defaultChecked?: boolean;
  readOnly?: boolean;
  capitalize?: boolean;
  style?: React.CSSProperties;
}

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  value,
  type = "checkbox",
  capitalize,
  defaultChecked,
  readOnly,
  style,
  children,
}) => (
  <span style={style}>
    {readOnly && defaultChecked && (
      <input name={name} type="hidden" value={value} />
    )}
    <input
      className={styles.input}
      id={type === "radio" ? value : name}
      value={value}
      type={type}
      name={name}
      defaultChecked={defaultChecked}
      disabled={readOnly}
    />
    <label
      htmlFor={type === "radio" ? value : name}
      className={classNames(styles.label, capitalize && styles.capitalize)}
    >
      <span className={styles.overlay} />
      <Icon className={styles.checked} name={CHECKED_ICONS[type]} />
      <Icon className={styles.unchecked} name={UNCHECKED_ICONS[type]} />
      {children}
    </label>
  </span>
);

export type { CheckboxProps };
export { Checkbox };
